








































import { Component, Prop, Watch, Vue } from "vue-property-decorator";

import InputSearch from "@/components/app/search/input-search.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import FullProductCard from "@/components/card/menu/full-product-card.vue";
import RecuclerList from "./recucler-list.vue";

import { IProductCard, ICategory } from "@/@types/menu/menu/menu";
import { deleteElement, reestablishElement } from "@/api/delite/delite-element";
import { menu } from "@/config/host.config";
import SortProductByCategory from "../../app/dropdowns/menu/sort-product-by-category.vue";

interface ISortColumn {
  i: number;
  name: number;
  category: number;
}
@Component({
  components: {
    InputSearch,
    BSwitch,
    FullProductCard,
    RecuclerList,
    SortProductByCategory,
  },
})
export default class RecuclerMenuList extends Vue {
  @Prop({ type: Array, default: [] }) menuList!: IProductCard[];
  @Prop({ type: Array, default: [] }) categoryList!: ICategory[];
  @Prop({ type: String, default: "all-menu" }) activeBar!: string;

  list = this.menuList;
  showDetails = false;
  productDetails: IProductCard | null = null;

  columns = ["i", "name", "category"];
  search = "";
  sortKey = "";
  sortOrder: ISortColumn = { i: 1, name: 1, category: 1 };

  changeSeartch(seartch: string): void {
    this.search = seartch;
  }

  mustUpdateProductCard(data: IProductCard): void {
    this.productDetails = data;
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
    console.log(JSON.stringify(this.sortOrder));
  }

  @Watch("sortOrder", { deep: true })
  @Watch("search")
  filteredItems(): IProductCard[] {
    let menuList: IProductCard[] = [];
    for (const dish of this.list) {
      if (dish.name) {
        menuList.push(dish);
      }
    }
    const filterKey = this.search && this.search.toLowerCase();
    const order = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;
    if (filterKey) {
      return this.menuList.filter((item) => {
        if (item.name) {
          return (
            this.$getLocale(item.name)
              .toLowerCase()
              .indexOf(filterKey.toLowerCase()) > -1
          );
        }
      });
    }

    if (this.sortKey) {
      if (this.sortKey == "name") {
        menuList = menuList.slice().sort((a: IProductCard, b: IProductCard) => {
          const one = this.$getLocale(a.name);
          const two = this.$getLocale(b.name);
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }
      if (this.sortKey == "i") {
        return this.sortOrder.i > 0 ? menuList.reverse() : menuList;
      }
      if (this.sortKey == "category") {
        const categoryList = this.categoryList
          .slice()
          .sort((a: ICategory, b: ICategory) => {
            const one = this.$getLocale(a.name);
            const two = this.$getLocale(b.name);
            return (one === two ? 0 : one > two ? 1 : -1) * order;
          });

        let newArr: IProductCard[] = [];
        for (const cat of categoryList) {
          for (let i = 0; i < menuList.length; i++) {
            if (menuList[i].category == cat._id) {
              newArr.push(menuList[i]);
            }
          }
        }
        return newArr;
      }
    }

    return menuList;
  }

  sortMeluListByCategory(categoty_id: string | null): void {
    this.list = [];
    if (categoty_id != null) {
      for (const category of this.menuList) {
        if (categoty_id == category.category) {
          this.list.push(category);
        }
      }
    } else {
      this.list = this.menuList;
    }
  }

  showFullProductCard(product: IProductCard): void {
    this.productDetails = product;
    this.showDetails = true;
  }

  @Watch("activeBar")
  closedDetails(): void {
    this.showDetails = false;
    this.productDetails = null;
  }

  async deleteDish(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("Menu.confirm.deleted")),
        }
      );

      if (result != true) return;
      this.closedDetails();
      const url = menu.forceDelete;
      deleteElement(id, url)
        .then(() => {
          this.$notify({
            group: "global",
            text: String(this.$i18n.t("error.200")),
          });

          this.$emit("deletedProduct", id);
        })
        .catch((e) => {
          console.log(e.message);
        });
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  restoreDish(id: string): void {
    const url = menu.restore;
    reestablishElement(id, url)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });

        this.$emit("deletedProduct", id);
      })
      .catch((e) => {
        console.log(e.message);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.empty400")),
          type: "warn",
        });
      });
  }

  mounted(): void {
    this.$watch(
      "menuList",
      function () {
        this.list = this.menuList;
      },
      { deep: true }
    );
  }

  destroyed(): void {
    this.search = "";
    this.showDetails = false;
    this.productDetails = null;
  }
}
